<template>
  <div>
    <div class="total-data">
      <ul>
        <li v-for="item in data" :key="item.name">
          <div class="total-data-title margin-bottom-10">{{ item.name }}</div>
          <div class="total-data-num">
            {{ item.data }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [
        { name: '', data: 0 },
        { name: '', data: 0 },
      ],
    },
  },
};
</script>
<style lang="scss" scoped>
.total-data {
  text-align: left;
  padding-left: 100px;
  ul {
    display: flex;
    li {
      margin-right: 200px;
      .total-data-title {
        font-size: 14px;
      }
      .total-data-num {
        font-size: 26px;
        font-weight: bold;
      }
    }
  }
}
</style>
